import Progress from './progress';
import Base from '../base';

export { ProgressProps } from './progress';

/* istanbul ignore next */
Progress.install = function (Vue) {
  Vue.use(Base);
  Vue.component(Progress.name, Progress);
};

export default Progress;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/es/progress/index.js
// module id = null
// module chunks = 